import { FC } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../utils/context/Auth/AuthContext.tsx";

import { Routes } from "./routes";

type ProtectedRouteProps = {
  children: React.ReactNode;
};

export const ProtectedRoute: FC<ProtectedRouteProps> = ({
                                                          children,
                                                        }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <>{children}</>;
  } else {
    return <Navigate to={Routes.SignIn} replace />;
  }
};
